import { render } from "./AktivasiView.vue?vue&type=template&id=58485cf7&scoped=true"
import script from "./AktivasiView.vue?vue&type=script&lang=js"
export * from "./AktivasiView.vue?vue&type=script&lang=js"

import "./AktivasiView.vue?vue&type=style&index=0&id=58485cf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58485cf7"]])

export default __exports__